// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action } from "mobx";
import { NextTravelApi } from "../api/next-travel.api";

export default class NextTravelStore {
  @observable nextTravel: any = [];
  @observable cardProfileId: number = 0;
  @observable bonusesResident: number = 0;
  @observable isLoadingNextTravel: boolean = false;
  @observable errorNextTravel: string = "";

  @action calculateNextTravel = async (tim: string) => {
    if (!tim) {
      this.errorNextTravel = "TIM number is required";
      return;
    }

    this.isLoadingNextTravel = true;
    this.errorNextTravel = "";

    try {
      const cacUserProfile = await NextTravelApi.getCacUserProfile(tim);
      const walletInfo = await NextTravelApi.getMyWalletInfo();

      if (!cacUserProfile || !walletInfo) {
        this.errorNextTravel = "Unable to fetch user data";
        this.isLoadingNextTravel = false;
        return;
      }

      let array = [];
      for (let i = 0; i < 5; i++) {
        const res = await NextTravelApi.getNextTravel(
          i,
          walletInfo.points,
          cacUserProfile.profileId
        );
        
        if (res !== undefined) {
          array.push({ hops: i, price: Math.round((res / 100) * 100) / 100 });
        }
      }

      this.nextTravel = array;
      this.cardProfileId = cacUserProfile.profileId;
    } catch (error) {
      console.error("Error calculating next travel:", error);
      this.errorNextTravel = "An error occurred while calculating next travel";
    } finally {
      this.isLoadingNextTravel = false;
    }
  };

  @action getBonusesResident = async (profileId: number) => {
    if (!profileId) {
      return;
    }

    try {
      const res = await NextTravelApi.getBonusesResident(profileId);
      
      if (res && res.pointCost !== undefined) {
        this.bonusesResident = res.pointCost;
      }
    } catch (error) {
      console.error("Error fetching bonuses resident:", error);
    }
  };
}
